import React from 'react';

const PageComponents = {
    ChartOperationalCosts12Months: React.lazy(() => import('./ChartOperationalCosts12Months')),
    ChartOperationalCosts3Years: React.lazy(() => import('./ChartOperationalCosts3Years')),
    ChartMillSales: React.lazy(() => import('./ChartMillSales')),
    ChartOperationalCosts: React.lazy(() => import('./ChartOperationalCosts')),


    
};

export default PageComponents;
